import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 14 2",
  "content": "<symbol viewBox=\"0 0 14 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus\">\n<path d=\"M10.375 0.25H12H13C13.41 0.25 13.75 0.59 13.75 1C13.75 1.41 13.41 1.75 13 1.75H6.99927H6.25H4.67268H1C0.59 1.75 0.25 1.41 0.25 1C0.25 0.59 0.59 0.25 1 0.25H7H7.75H10.375Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol